import moment from "moment-jalaali";

export const ToPersianDate = (date) => {
  if (date) {
    return moment(date, "YYYY-M-D HH:mm:ss").format("jYYYY/jM/jD HH:mm:ss");
  } else {
    return null;
  }
};

export const BiggerTime = (SimDebit, carTime) => {
  if (!SimDebit && !carTime) {
    return 1000000;
  } else if (SimDebit && !carTime) {
    return Math.floor(SimDebit / 1000.0);
  } else if (!SimDebit && carTime) {
    return Math.floor(carTime / 1.0);
  } else {
    let SimDebitSecond = Math.floor(SimDebit / 1000.0);
    let returnValue =
      SimDebitSecond > carTime
        ? Math.floor(SimDebitSecond / 1.0)
        : Math.floor(carTime / 1.0);
    return returnValue;
  }
};

export const HandelShowPrice = (AllCar, SelectedCarId, Period) => {
  let Device = [];
  SelectedCarId.map((item) => {
    Device.push(AllCar.find((x) => x.DeviceID === item));
  });
  let prices = 0;
  Device.map((item) => (prices += item.Price));
  switch (Period) {
    case 6:
      return (prices / 20).toFixed(0);
    case 12:
      return prices / 10;
    case 24:
      return ((prices * 2) / 10).toFixed(0);
    default:
      return 0;
  }
};

export const ToPersian = (En) => {
  let Persian = [];
  `${En}`.split("").map((item) => {
    switch (item) {
      case "0":
        Persian.push("۰");
        break;
      case "1":
        Persian.push("۱");
        break;
      case "2":
        Persian.push("۲");
        break;
      case "3":
        Persian.push("۳");
        break;
      case "4":
        Persian.push("۴");
        break;
      case "5":
        Persian.push("۵");
        break;
      case "6":
        Persian.push("۶");
        break;
      case "7":
        Persian.push("۷");
        break;
      case "8":
        Persian.push("۸");
        break;
      case "9":
        Persian.push("۹");
        break;
      case ",":
        Persian.push(",");
        break;
      case "/":
        Persian.push("/");
        break;
      case ":":
        Persian.push(":");
        break;
      case " ":
        Persian.push(" ");
        break;
      default:
        break;
    }
  });
  return Persian.join("");
};

export const handleSplitDateToObj = (timeString) => {
  let obj = {};
  let splitArr = timeString.split("-");
  obj.year = parseInt(splitArr[0]);
  obj.month = parseInt(splitArr[1]);
  obj.day = parseInt(splitArr[2]);
  return obj;
};

export const handleJoinDateFromObj = (
  obj = { year: 1400, month: 12, day: 10 }
) => {
  const handleTwoDigit = (number) => {
    if (number < 10) return `0${number}`;
    else return number;
  };
  return `${obj.year}-${handleTwoDigit(obj.month)}-${handleTwoDigit(obj.day)}`;
};

export const PriceFormat = (value) => {
  return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
